module.exports = __webpack_public_path__ + "img/shipment.a983d0e7.svg";